var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.833 2.5h.834c.916 0 1.666.75 1.666 1.667v12.5c0 .916-.75 1.666-1.666 1.666H3.333c-.916 0-1.666-.75-1.666-1.666v-12.5c0-.917.75-1.667 1.666-1.667h.834v-.833c0-.459.375-.834.833-.834.458 0 .833.375.833.834V2.5h8.334v-.833c0-.459.375-.834.833-.834.458 0 .833.375.833.834V2.5zM4.167 16.667h11.666a.836.836 0 00.834-.834V6.668H3.333v9.167c0 .458.375.833.834.833zM5.833 10a.833.833 0 100-1.667.833.833 0 000 1.667z",
    fill: "#332C4A"
  })));
};

export default SvgCalendar;